import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

interface CourseCreateStepTwoProps {
  courseData: {
    category_id: string;
    name: string;
    planned_time: string;
  };
  onDataChange: (
    data: Partial<{
      category_id: string;
      name: string;
      planned_time: string;
    }>
  ) => void;
  categories: any[];
  setStep: (step: number) => void;
}

const validationSchema = Yup.object({
  category_id: Yup.string().required("Выберите категорию"),
});

const CourseCreateStepTwo = ({
  courseData,
  onDataChange,
  categories,
  setStep,
}: CourseCreateStepTwoProps) => {
  return (
    <Formik
      initialValues={{
        category_id: courseData.category_id || "",
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        onDataChange(values);
        setSubmitting(false);
      }}>
      {({ errors, touched, handleChange, handleBlur, values }) => (
        <Form>
          <div className="course-content">
            <div className="course-content-title">
              Какая категория лучше всего подходит к теме вашего будущего курса?
            </div>
            <div className="course-content-description">
              Если вы пока не определились с категорией, ничего страшного.
              <br />
              Ее можно будет потом отредактировать.
            </div>

            <FormControl
              fullWidth
              sx={{ marginTop: "32px" }}
              error={touched.category_id && !!errors.category_id}>
              <InputLabel id="category-label">Выберите категорию</InputLabel>
              <Field
                as={Select}
                name="category_id"
                labelId="category-label"
                label="Выберите категорию"
                value={values.category_id}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.category_id && Boolean(errors.category_id)}>
                {categories.map((category: any) => (
                  <MenuItem key={category.id} value={category.id}>
                    {category.name}
                  </MenuItem>
                ))}
              </Field>
              {touched.category_id && errors.category_id && (
                <FormHelperText>{errors.category_id}</FormHelperText>
              )}
            </FormControl>
            <div className="course-create-footer">
              <Box
                sx={{
                  position: "fixed",
                  right: 0,
                  bottom: 0,
                  background: "#ffffff",
                  borderTop: "1px solid rgba(1, 18, 36, 0.08)",
                  padding: "12px 32px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  zIndex: 1000,
                  boxSizing: "border-box",
                }}>
                <Button variant="outlined" onClick={() => setStep(1)}>
                  Назад
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ marginLeft: "auto" }}>
                  Продолжить
                </Button>
              </Box>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default CourseCreateStepTwo;
